import { AbstractControl, ValidatorFn } from '@angular/forms';

export function startDateLessThanEndDateValidator(startKey: string, endKey: string): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
        const start = group.get(startKey)?.value;
        const end = group.get(endKey)?.value;

        if (start === null || end === null) {
            return null; // Do not return an error if either date is null
        }

        return start > end ? { isStartDateLessThanEndDate: true } : null;
    };
}
